import omitDeleted from './omitDeleted';

const mapNodes = (edges: any[], mapFunc?: (node: any) => any) => {
  const nodes = omitDeleted(edges.map((e) => e.node || {})) as any[];
  return mapFunc ? nodes.map(mapFunc) : nodes;
};

export default mapNodes;
